import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../footer/footer.css';

export default class footer extends Component {
    render() {
        return (
            <div>
                 <div className="footer_main">
                 {/* <!-- footer start --> */}
    <footer id="footer_main">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 first_col">
            <div className="row">
              <div className="col-sm-4">
                <h3>About us</h3>
                <ul className="m-0 p-0">
                  <li><Link to="/nearme">Near me</Link></li>
                  <li><Link to="/privacy">Privacy Policy</Link></li>
                </ul>
              </div>
              <div className="col-sm-4">
                <h3>Blogs</h3>
                <ul className="m-0 p-0">
                  <li><Link to="/blogs">FAQs</Link></li>
                </ul>
              </div>
              <div className="col-sm-4">
                <h3>Service</h3>
                <ul className="m-0 p-0">
                  <li><Link to="terms">Terms and condition</Link></li>
                </ul>
              </div>              
            </div>
          </div>
          <div className="col-md-6 col-lg-3 secoond_col">
            <h3>Partners</h3>
            <p>Become Link partner</p>
            <h3>Follow us on</h3>
            <ul className="m-0 p-0">
              <li><Link href="#"><i className="fa fa-instagram" aria-hidden="true"></i></Link></li>
              <li><Link href="#"><i className="fa fa-youtube-play" aria-hidden="true"></i></Link></li>
              <li><Link href="#"><i className="fa fa-twitter" aria-hidden="true"></i></Link></li>
            </ul>
          </div>
          <div className="col-md-6 col-lg-3 thrd_col">
            <h3>Get in touch</h3>
            <p>Street, 2862 Timbercrest Road.
              City, India</p>
            <h3>Secure payments</h3>
            <ul className="m-0 p-0">
              <li><Link href="#"><i className="fa fa-cc-visa" aria-hidden="true"></i></Link></li>
              <li><Link href="#"><i className="fa fa-cc-paypal" aria-hidden="true"></i></Link></li>
              <li><Link href="#"><i className="fa fa-cc-amex" aria-hidden="true"></i></Link></li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    {/* <!-- footer end --> */}
                </div>
            </div>
        )
    }
}
